import { observable, action, computed } from 'mobx';
import agent from '../services/web/agent';
import OIDCStore from './oidcStore';

class ConfigurationsStore {

    defaultTenantName = "checkmarx";

    @observable isMultitenancyMode = null;
    @observable isDefaultTenant = null;
    @observable scaUrl = '';
    @observable registrationLink = null;
    @observable isRequiredEulaHosted = null;
    @observable isAssignAllRolesByManageUsersEnabled = null;


    @action updateStore() {
        this.setConfigurations();
        this.setIsDefaultTenant();
    }

    @action setConfigurations() {
        return agent.Configurations.getConfigurations()
            .then(action((configurations) => {
                this.isMultitenancyMode = configurations.isMultitenancyMode;
                if(configurations.scaUrl){
                    this.scaUrl = configurations.scaUrl;
                }
                if(configurations.registrationLink){
                    this.registrationLink = configurations.registrationLink;
                }
                if(configurations.isAssignAllRolesByManageUsersEnabled){
                    this.isAssignAllRolesByManageUsersEnabled = configurations.isAssignAllRolesByManageUsersEnabled;
                }
                if (configurations.isRequiredEula) {
                    this.isRequiredEulaHosted = configurations.isRequiredEula;
                }
            }));
    }

    @action setIsDefaultTenant() {
        try {
            return this.isDefaultTenant = OIDCStore.currentUser.profile.tenant_name.toLowerCase() == this.defaultTenantName;
        } catch (error) {
            return this.isDefaultTenant = false;
        }
    }
}

export default new ConfigurationsStore();


